import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
};

export const isPushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const getPushSubscription = async () => {
  if (!isPushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  if (!reg) return null;
  return reg.pushManager.getSubscription();
};

export const subscribeToPush = async () => {
  if (!isPushSupported()) throw new Error("not_supported");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("permission_denied");

  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;

  const { data } = await axios.get(`${API}/push/vapid-public-key`);
  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key)
  });

  await axios.post(`${API}/push/subscribe`, subscription.toJSON(), { withCredentials: true });
  return subscription;
};

export const unsubscribeFromPush = async () => {
  const subscription = await getPushSubscription();
  if (subscription) {
    await axios.post(`${API}/push/unsubscribe`, { endpoint: subscription.endpoint }, { withCredentials: true });
    await subscription.unsubscribe();
  }
};
